var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    'full-width-btn':
      _vm.$vuetify.breakpoint.width < 501 && !_vm.round && _vm.incompleteAccountWidget,
  }},[_c('button',{staticClass:"d-flex align-center justify-center",class:{
      'full-width gala-film-btn white-btn colored x-small':
        !_vm.incompleteAccountWidget,
      'gala-film-btn purple-btn white-text px-4': !_vm.round,
      'wallet-creation': _vm.incompleteAccountWidget && !_vm.round,
      'full-width':
        (_vm.$vuetify.breakpoint.width < 501 && !_vm.round) || _vm.buttonFullWidth,
      round: _vm.round,
    },on:{"click":_vm.handleClick}},[(_vm.round)?_c('v-icon',{attrs:{"color":"textColor","size":"28"}},[_vm._v("\n      keyboard_arrow_right\n    ")]):_c('span',{class:{ 'font--button-medium': _vm.incompleteAccountWidget }},[_vm._v("\n      "+_vm._s(_vm.buttonText)+"\n    ")])],1),_vm._v(" "),_c('WalletCreationModalFlow',{attrs:{"settingGyriPassphrase":_vm.settingGyriPassphrase},on:{"success":function($event){return _vm.$emit('success')}},model:{value:(_vm.showModals),callback:function ($$v) {_vm.showModals=$$v},expression:"showModals"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }